<template>
  <div>
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        id="Scroll"
        pagination
        :max-items="itemsPerPage"
        search
        :page="currentPage"
        :data="ComplaintSuggestions"
      >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">
                {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{ ComplaintSuggestions.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : ComplaintSuggestions.length }}
                of {{ ComplaintSuggestions.length }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 4"><span>4</span></vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10"><span>10</span></vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 15"><span>15</span></vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20"><span>20</span></vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="Code">{{ $t("ComplaintCode") }}</vs-th>
          <vs-th sort-key="Investor">{{ $t("UserName") }}</vs-th>
          <vs-th sort-key="Type">{{ $t("Type") }}</vs-th>
          <vs-th sort-key="Status">{{ $t("Status") }}</vs-th>
          <vs-th sort-key="Date">{{ $t("Date") }}</vs-th>
          <vs-th>{{ $t("Actions") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <tr
              v-for="(tr, indextr) in data"
              :key="indextr"
              @click="AddOrEditData(tr)"
              class="cursor-pointer"
            >
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Code }}</p>
              </vs-td>

              <vs-td>
                <p class="font-medium">{{ tr.UserName }}</p>
              </vs-td>

              <vs-td>
                <vs-chip :color="tr.Type === 1 ? 'danger' : 'primary'">
                  {{ tr.Type === 1 ? $t('Complaint') : $t('Suggestion') }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip :color="getStatusColor(tr.Status)" class="product-status">
                  {{ getStatusText(tr.Status) }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <p>{{ formatDate(tr.CreatedDate) }}</p>
              </vs-td>

             <vs-td class="whitespace-no-wrap">
                <!-- ضفنا flex و items-center هنا -->
                <div class="icon-container flex items-center">
                  
                  <vx-tooltip :text="$t('Show Details')" position="top">
                    <feather-icon
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      @click.stop="AddOrEditData(tr)"
                    />
                  </vx-tooltip>

                  <vx-tooltip color="red" :text="$t('Delete')" position="top">
                    <!-- ضفنا mr-2 أو ml-2 للمسافة حسب اتجاه لوحة التحكم RTL أو LTR -->
                    <feather-icon
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current mx-2"
                      @click.stop="openConfirm(tr)"
                    />
                  </vx-tooltip>

                </div>
              </vs-td>
            </tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import moduleComplaintSuggestion from "@/store/ComplaintSuggestions/moduleComplaintSuggestion.js";

export default {
  data() {
    return {
      itemsPerPage: 10,
      isMounted: false,
    };
  },
  computed: {
    currentPage() {
      return this.isMounted && this.$refs.table ? this.$refs.table.currentx : 1;
    },
    ComplaintSuggestions() {
      return this.$store.state.ComplaintSuggestionsList.ComplaintSuggestions;
    },
  },
  methods: {

    getStatusColor(status) {
      if (status === 1) return "warning"; // معلقة
      if (status === 2) return "success"; // انتهت
      return "grey"; // جديدة (null)
    },
    getStatusText(status) {
      if (status === 1) return this.$t("Pending");
      if (status === 2) return this.$t("Completed");
      return this.$t("New");
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString(this.$i18n.locale === 'ar' ? 'ar-EG' : 'en-US');
    },
    AddOrEditData(data) {
      const id = data.Id || data.ID || 0;
   
      this.$router.push(`/ComplaintSuggestions/ViewComplaintSuggestions/${id}`);
    },
    openConfirm(tr) {
  
       this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('Confirm Delete'),
        text: `${this.$t('Are you sure you want to delete')} ${tr.Code}?`,
        accept: () => this.deleteItem(tr)
      });
    },
    deleteItem(tr) {
      this.$store.dispatch("ComplaintSuggestionsList/removeItem", tr.Id)
        .then(() => { this.$vs.notify({ title: this.$t('Success'), color: 'success' }); })
        .catch(() => { this.$vs.notify({ title: this.$t('Error'), color: 'danger' }); });
    }
  },
  created() {
    if (!moduleComplaintSuggestion.isRegistered) {
      this.$store.registerModule("ComplaintSuggestionsList", moduleComplaintSuggestion);
      moduleComplaintSuggestion.isRegistered = true;
    }
    this.$store.dispatch("ComplaintSuggestionsList/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>